import {mapActions,  mapState} from "pinia";
import useModuleStore from "../stores";
import useApplicationStore from "../stores/application_module";
import {Contact} from "../entities";
import * as types from "../stores/constants";
import {defaultCountry, defaultCurrency, defaultPhoneCode} from "../entities/default";
import moment from 'moment';
import EventBus from "./event_bus";
import {CONVERT_PUBLIC_QUOTE} from "../stores/constants";

const STANDALONE_SERVICE = "STANDALONE_SERVICE";
const ACCESSORY = "ACCESSORY";
const GLOBAL_FEATURE = "GLOBAL_FEATURE";
export default {
    data (){
        return {
            isEditMode: true, //helps check which parent component is mounted
            page_steps: {
              STEP_ONE: 'STEP_ONE',
              STEP_TWO: 'STEP_TWO',
              STEP_THREE: 'STEP_THREE',
              STEP_FOUR: 'STEP_FOUR',
            },
            business_types: {
                SOLE_TRADER: "ST",
                LIMITED: "L",
                LIMITED_PARTNERSHIP: "LP",
                LIMITED_LIABILITY_PARTNERSHIP: "LLP",
                PARTNERSHIP: "PART",
                GENERAL_PARTNERSHIP: 'GP',
                PUBLIC_LIMITED_COMPANY: "PL",
                TRUST: "TR",
                CHARITY: "CH",
                SOCIETY: "SOC",
                CLUB: "CL",
                JOINT_STOCK_COMPANY: "JSC",
            },
            PRINCIPAL_RULES:{
                LEVEL_PRINCIPAL: 'P',
                LEVEL_APPLICATION: 'A',
                CRITERIA_ALL_MANDATORY_ROLE: 'AM',
                CRITERIA_ONE_OF_MANDATORY_ROLE: 'OM',
                CRITERIA_EQ: 'EQ',  //equal
                CRITERIA_GT: 'GT',  //Great Than
                CRITERIA_GE: 'GE',  //Great than or Equal
                CRITERIA_LT: 'LT',  //Less Than
                CRITERIA_LE: 'LE',  //Less than or Equal
            },
            PRINCIPAL_ROLES: {
                AUTHORISED_SIGNER: 'AS',
                BENEFICIAL_OWNER: 'BO',
                RESPONSIBLE_PARTY: 'RP',
                DIRECTOR: 'D',
            },
            TYPE_OF_BANK_PARAM: [
                {'id': 'CHARGEBACK', 'text': this.lang('chargeback')},
                {'id': 'CREDIT', 'text': this.lang('billing')},
                {'id': 'DEBIT', 'text': this.lang('bank_type_deposit')},
            ],
            edit_address: false,
            allow_manual_edit: false,
            primary_titles: ['Mr.', 'Mrs.', 'Miss.'],
            disableContinueBtn: false,
            payment_method: {
                PAYMENT_METHOD_F2F_ONLY: "1",
                PAYMENT_METHOD_ECOM_ONLY: "2",
                PAYMENT_METHOD_BOTH: "3",
            },
            quote_offer_updated_by_outlet: false,
            quote_multi_signer: '2',
            default_currencies_to_format: {
                'SEK': {
                    locale: 'sv-SE',
                    search_value: 'SEK',
                    replace_value: 'Kr'
                },
                'NOK': {
                    locale: 'sv-SE',
                    search_value: 'Nkr',
                    replace_value: 'Kr'
                }
            },
            app_default_param: {
                COUNTRY_CODE: "country_code",
                ENTITY_BLOCK_BUSINESS: "BUSINESS",
                ENTITY_BLOCK_ALL_OUTLET: "ALL_OUTLET",
                ENTITY_BLOCK_MAIN_OUTLET: "MAIN_OUTLET",
            },
        }
    },
    computed: {
        ...mapState(useModuleStore,{
            user:'user',
            merchant_user_access:'merchant_user_access',
            global_errors:'global_errors',
            alliance:'alliance'}),
        ...mapState(useApplicationStore, {
            can_view:'can_view',
            can_edit:'can_edit',
            quote:'quote',
            quote_lock:'quote_lock',
            parameters:'parameters',
            merchant:'merchant',
            merchant_relation:'merchant_relation',
            merchant_users:'merchant_users',
            application_root_path:'application_root_path',
            quote_root_path:'quote_root_path',
            outlets:'outlets',
            equipment_offer:'equipment_offer',
            online_offer:'online_offer',
            application_tabs:'application_tabs',
            business_info_subtabs:'business_info_subtabs',
            business_details_subtabs:'business_details_subtabs',
            disable_go_back_warning_modal:'disable_go_back_warning_modal',
            portal_tabs:'portal_tabs',
            paypal_boarding:'paypal_boarding'}),

        isPublicUser: function () {
            return this.user.is_public_user == '1';
        },
        isInitialAppDataFetchCompleted: function () {
            if (this.objectIsNotEmpty(this.merchant)) {
                if (!!this.merchant.quote_external_id && !this.objectIsNotEmpty(this.quote)) {
                    return false;
                }
                return true;
            }
            return false;
        },
        isSignerUser: function () {
            return this.user.is_signer_user == '1';
        },
        multiplePrincipalsCanSign: function () {
            if (!!this.merchant.owners && this.merchant.owners.length > 0) {
                let owners = this.merchant.owners.filter(owner => owner.is_signatory == '1');
                return owners.length > 1;
            }
            return false;
        },
        regNumberLabel: function() {
            if (this.baseCountryCode === '616') {
                return this.lang('regon_reg_number');
            }
            return this.lang('company_registration_number');
        },
        paramBusinessSectorsSB: function () { //filter for SB
            let vm = this;
            let sectors = [];
            if (!!vm.parameters && vm.parameters.hasOwnProperty('BUSINESS_SECTORS')) {
                this.parameters.BUSINESS_SECTORS.forEach(mcc => {
                    if (mcc.hasOwnProperty('self_boarding') && mcc.self_boarding === '1') {
                        sectors.push(mcc);
                    }
                });
            }
            return sectors;
        },
        paramBusinessMCCSB: function (){ //self boarding mccs
            let vm = this;
            let mcc_codes = [];
            if (!!vm.parameters && vm.parameters.hasOwnProperty('MCC_CODES_PARAM')) {
                mcc_codes = this.parameters.MCC_CODES_PARAM.filter(obj => { return obj.self_boarding === '1'})
            }
            return mcc_codes;
        },
        paramBusinessTypeSB: function (){ //self boarding business type
            let vm = this;
            let has_business_type_param = vm.parameters && vm.parameters.hasOwnProperty('BUSINESS_TYPE_PARAM');

            return has_business_type_param ? vm.parameters['BUSINESS_TYPE_PARAM'].filter(obj => {
                return obj.hasOwnProperty('self_boarding') && obj.self_boarding === '1';
            }) : [];
        },
        randomReference: function (){
            return Math.random().toString().replace('.', '')
        },
        partnershipBusinessTypes: function () {
            return [
                this.business_types.LIMITED_PARTNERSHIP,
                this.business_types.LIMITED_LIABILITY_PARTNERSHIP,
                this.business_types.PARTNERSHIP,
                this.business_types.GENERAL_PARTNERSHIP
            ]
        },
        merchantReference: function () {
            let vm = this;
            if (!!vm.merchant && !!vm.merchant.application_external_id) {
                return {'custom_key': 'EXISTING_MERCHANT', 'custom_value': vm.merchant.application_external_id};
            } else {
                return {'custom_key': 'NEW_MERCHANT', 'custom_value': vm.randomReference};
            }
        },
        quoteReference: function () {
            let vm = this;
            if (!!vm.quote && !!vm.quote.quote_external_id) {
                return {'custom_key': 'EXISTING_QUOTE', 'custom_value': vm.quote.quote_external_id};
            } else {
                return {'custom_key': 'NEW_QUOTE', 'custom_value': vm.randomReference};
            }
        },
        quoteIsEcom: function () {
            return this.quote.payment_method === this.payment_method.PAYMENT_METHOD_ECOM_ONLY;
        },
        isLargeMoto: function (){
            return this.outlet.sales_moto_perc > 10;
        },
        isBlendedMid: function () {
            let vm = this;
            if (!vm.hasTenantAppDefaults)
                return false;

            let is_blended_mid = vm.parameters.TENANT_APP_DEFAULTS_PARAM.find(data => {
                if (data['field_name'] === 'blended_mids_off'  && data['selfboarding_default_value'] === '0'){
                    return true;
                }
            });

            return !!is_blended_mid;
        },
        isQuoteLimited: function () {
            return this.quote.ownership_entity_type === this.business_types.LIMITED || this.quote.ownership_entity_type === this.business_types.PUBLIC_LIMITED_COMPANY;
        },
        isQuotePartnership: function (){
            return this.quote.ownership_entity_type === this.business_types.PARTNERSHIP
        },
        isQuotePartnershipLLP: function () { //LLP
            return this.quote.ownership_entity_type === this.business_types.LIMITED_LIABILITY_PARTNERSHIP
        },
        isCharity: function () {
            if(!!this.merchant && !!this.merchant.ownership_entity_type) {
                return this.merchant.ownership_entity_type === this.business_types.TRUST || this.merchant.ownership_entity_type === this.business_types.CHARITY;
            }

            return false;
        },
        isSoleTrader: function  (){
            if(!!this.merchant && !!this.merchant.ownership_entity_type) {
                return this.merchant.ownership_entity_type === this.business_types.SOLE_TRADER;
            }
            return false;
        },
        isLimited: function () {
            if (!!this.merchant && !!this.merchant.ownership_entity_type) {
                return this.merchant.ownership_entity_type === this.business_types.LIMITED || this.merchant.ownership_entity_type === this.business_types.PUBLIC_LIMITED_COMPANY;
            }
            return false;
        },
        isLimitedCompany: function () {
            if (!!this.merchant && !!this.merchant.ownership_entity_type) {
                return this.merchant.ownership_entity_type === this.business_types.LIMITED
            }
            return false
        },
        allowedPOLBusinessTypes: function(){
            let tenant_country = $('body#portal').data('tenant-country');
            if(tenant_country == '616'){
                return (this.merchant.ownership_entity_type === this.business_types.JOINT_STOCK_COMPANY || this.merchant.ownership_entity_type === this.business_types.PARTNERSHIP)
            }
            return false
        },
        isPublicLimitedCompany: function () {
            if (!!this.merchant && !!this.merchant.ownership_entity_type) {
                return this.merchant.ownership_entity_type === this.business_types.PUBLIC_LIMITED_COMPANY
            }
            return false
        },
        isPartnership: function () {
            if (!!this.merchant && !!this.merchant.ownership_entity_type) {
                return this.merchant.ownership_entity_type === this.business_types.PARTNERSHIP
            }
            return false;
        },
        isPartnershipLLP: function () { //LLP
            return this.merchant.ownership_entity_type === this.business_types.LIMITED_LIABILITY_PARTNERSHIP
        },
        isPartnershipType: function (){
            return this.partnershipBusinessTypes.includes(this.merchant.ownership_entity_type)
        },
        isJoinStockCompany: function () { //LLP
            return this.merchant.ownership_entity_type === this.business_types.JOINT_STOCK_COMPANY
        },
        isGermanAlliance: function () {
            return (this.baseCountryCode === '276');
        },
        isRegNumberRequired: function() {
            let vm = this;
            return vm.isGermanAlliance ? vm.regNumberRequiredByAnnualTurnover : vm.canShowRegNumber;
        },
        isQuoteRegNumberRequired: function() {
            let vm = this;
            return vm.isGermanAlliance ? vm.regNumberRequiredByAnnualTurnover : vm.canQuoteShowRegNumber;
        },
        isApplicationRegNumberRequired: function() {
            let vm = this;
            return vm.isGermanAlliance ? vm.regNumberRequiredByAnnualTurnover : vm.canApplicationShowRegNumber;
        },
        regNumberRequiredByAnnualTurnover: function() {
            let vm = this;
            return !!vm.quote && vm.quote.hasOwnProperty('annual_turnover') && vm.quote.annual_turnover.replace(/,/g, '') > 1000000;
        },
        canShowRegNumber: function (){
            //use one computed property to resolve this issue. canShowRegNumber will be deprecated later for the below
            //computed property
            return this.canApplicationShowRegNumber;

            let $tenant_country = $('body').data('tenant-country').toString();
            let can_show = this.isLimited || this.isPartnershipLLP;
            let show_all_country_code = ['616', '578'];

            if (show_all_country_code.includes($tenant_country)) { //Poland
                return true; //they asked us to show everything in 2142
            }
            return can_show;
        },
        canQuoteShowRegNumber: function (){
            switch (this.baseCountryCode) {
                case '826': //uk
                    return this.isQuoteLimited || this.isQuotePartnershipLLP;
                case '372': //Ireland
                    return this.isQuoteLimited || this.isQuotePartnershipLLP;
                case '616': //Poland
                    return true;
                case '752': //Sweden
                    return true;
                case '578': //Norway
                    return true;
                case '276': //Germany
                    return true;
                default:
                    return false;
            }
        },
        isRegNumberFirst: function (){
            switch (this.baseCountryCode) {
                case '752': //Sweden
                    return true;
                case '578': //Norway
                    return true;
                default:
                    return false;
            }
        },
        canApplicationShowRegNumber: function (){
            switch (this.baseCountryCode) {
                case '826': //uk
                    return this.isLimited || this.isPartnershipLLP;
                case '372': //Ireland
                    return this.isLimited || this.isPartnershipLLP;
                case '616': //Poland
                    return true;
                case '752': //Sweden
                    return true;
                case '578': //Norway
                    return true;
                case '276': //Germany
                    return true;
                default:
                    return false;
            }
        },
        isQuoteAllowCompanySearch: function () {
            switch (this.baseCountryCode) {
                case '826': //uk
                    return this.isQuoteLimited || this.isQuotePartnershipLLP;
                case '372': //Ireland
                    return this.isQuoteLimited || this.isQuotePartnershipLLP;
                case '616': //Poland
                    return this.isQuoteLimited || this.isQuotePartnershipLLP;
                case '752': //Sweden
                    return true;
                case '276': //Germany
                    return this.isQuoteLimited || this.isQuotePartnershipLLP;
                default:
                    return false;
            }
        },
        isApplicationAllowCompanySearch: function () {
            switch (this.baseCountryCode) {
                case '826': //uk
                    return this.isLimited || this.isPartnershipLLP;
                case '372': //Ireland
                    return this.isLimited || this.isPartnershipLLP;
                case '616': //Poland
                    let ownership_entity_type = this.merchant && this.merchant.ownership_entity_type ? this.merchant.ownership_entity_type:'';
                    let allowed = [this.business_types.JOINT_STOCK_COMPANY, this.business_types.PARTNERSHIP].includes(ownership_entity_type);
                    return this.isLimited || this.isPartnershipLLP || allowed;
                case '752': //Sweden
                    return true;
                case '276': //Germany
                    return this.isLimited || this.isPartnershipLLP;
                default:
                    return false;
            }
        },
        canUseVatToSearchBusiness: function() {
            return this.baseCountryCode === '616' && !!this.merchant && !!this.merchant.ownership_entity_type; //poland
        },
        isBisNodeSearch: function() {
            return this.baseCountryCode === '752'  || this.baseCountryCode === '578'; //Sweden Or Norway
        },
        registerNumberRule: function () {
            let rules = [];
            if (['752','578'].includes(this.baseCountryCode)) {
                rules.push('numeric');
            }
            else if (['276'].includes(this.baseCountryCode)) {
                rules.push('alpha_numeric_space');
            }
            else    {
                rules.push('alpha_numeric');
            }
            return rules;
        },
        primeTitles: function () {
            let titles = [],
                more = {id: 'other', text: this.lang('more'), value: 'other', label: this.lang('more')};

            if(this.parameters.hasOwnProperty('TITLES')){
                titles = this.parameters.hasOwnProperty('TITLES') ? this.parameters.TITLES.filter(obj => {
                    return this.primary_titles.includes(obj.id)
                }) : [];
                if (titles.length > 2) {
                    titles.push(more);
                }
            }
            return titles;
        },
        otherTitles: function () {

            //take first 3 titles.
            let titles = this.parameters.hasOwnProperty('TITLES') ? this.parameters.TITLES.filter(obj => {
                return !this.primary_titles.includes(obj.id)
            }) : [];
            return titles;
        },
        applicationStatusKey: function() {
            const params = (!!this.parameters && !!this.parameters['APPLICATION_STATUS_PARAM']) ? this.parameters['APPLICATION_STATUS_PARAM'] : [];
            const parameter = params.find((obj) => {
                return obj.id === this.merchant.application_status_external_id
            }) ;
            return !!parameter && parameter.hasOwnProperty('application_status_key') ? parameter.application_status_key : '-';
        },
        quoteStatusKey: function () {
            const params = (!!this.parameters && !!this.parameters['QUOTE_STATUS_PARAM']) ? this.parameters['QUOTE_STATUS_PARAM'] : [];
            const parameter = params.find((obj) => {
                return obj.id === this.quote.status_external_id
            });
            return !!parameter && parameter.hasOwnProperty('quote_status_key') ? parameter.quote_status_key : '-';
        },
        isConvertedQuote: function (){
            return this.quoteStatusKey === types.QUOTE_STATUS_CONVERTED || this.quote_lock;
        },
        isInitiatedQuote: function (){
            return this.quoteStatusKey === types.QUOTE_STATUS_INITIATED
        },
        isLockedQuote: function (){
            return this.quote.lock == '1';
        },
        inQuoteViewMode: function () {
            return this.quote_root_path.includes('quote/view');
        },
        inApplicationViewMode: function() {
          return this.application_root_path.includes('application/view');
        },
        isOpenApplication: function()  {
            if (this.applicationStatusKey === '-'){
                return true;
            }
            return  this.applicationStatusKey === types.APP_STATUS_OPEN;
        },
        isPiiDataMaskedBank: function()  {
            return this.merchant?.pii_masked_bank == '1';
        },
        isPiiDataMaskedOwner: function()  {
            return this.merchant?.pii_masked_owner == '1';
        },
        isPiiDataMaskedDocument: function()  {
            return this.merchant?.pii_masked_document == '1';
        },
        isPiiMasked: function()  {
            return this.merchant?.pii_masked == '1';
        },
        cannotBeInEditFlow: function () {
            return !this.hasMerchantControl || this.isSignerUser;
        },
        isDocumentUploadAllowed: function()  {
            const document_upload_status = {
                'QUALITY_CHECK_MORE_DOCUMENT_REQUIRED': types.APP_STATUS_QUALITY_CHECK_MORE_DOCUMENT_REQUIRED,
            };

            return document_upload_status.hasOwnProperty(this.applicationStatusKey);
        },
        hasMerchantControl: function(){
            return ( !!this.merchant.merchant_control && this.merchant.merchant_control === '1' )
        },
        merchantToUpload: function(){
            return ( !!this.merchant.merchant_to_upload_document && this.merchant.merchant_to_upload_document === '1'  )
        },
        isAwaitingSignature: function()  {
            return this.applicationStatusKey === types.APP_STATUS_AWAITING_SIGNATURE;
        },
        isAwaitingPaperSignature: function () {
            return this.applicationStatusKey === types.APP_STATUS_AWAITING_PAPER_SIGNATURE;
        },
        isUnlockable: function (){
            const unlock_status = {
                'DOCUMENT_PACKET_GENERATION_FAILED': types.APP_STATUS_DOCUMENT_PACKET_GENERATION_FAILED,
                'AWAITING_SIGNATURE': types.APP_STATUS_AWAITING_SIGNATURE,
                'AWAITING_REMOTE_SIGNATURE': types.APP_STATUS_AWAITING_REMOTE_SIGNATURE,
                'AWAITING_PAPER_SIGNATURE': types.APP_STATUS_AWAITING_PAPER_SIGNATURE,
                'AWAITING_ON_SCREEN_SIGNATURE': types.APP_STATUS_AWAITING_ON_SCREEN_SIGNATURE,
                'SUBMISSION_FAILED': types.APP_STATUS_SUBMISSION_FAILED,
                'READY_FOR_QUALITY_CHECK': types.APP_STATUS_READY_FOR_QUALITY_CHECK,
                'DATA_COLLECTION_COMPLETE': types.APP_STATUS_DATA_COLLECTION_COMPLETE,
                'AML_MORE_INFO_REQUIRED': types.APP_STATUS_AML_MORE_INFO_REQUIRED,
                'QUALITY_CHECK_MORE_INFO_REQUIRED': types.APP_STATUS_QUALITY_CHECK_MORE_INFO_REQUIRED
            };
            let is_unlockable_application_status = unlock_status.hasOwnProperty(this.applicationStatusKey);

            let is_complete_signature_url = !!this.$route && !!this.$route.params && !!this.$route.params.signature_status
                && this.$route.params.signature_status === 'complete';
            let cannot_unlock_by_url = is_complete_signature_url && this.applicationStatusKey === 'AWAITING_SIGNATURE';

            return is_unlockable_application_status && !cannot_unlock_by_url && !this.isSignerUser;
        },
        hasTenantAppDefaults: function (){
            return !!this.parameters && this.parameters.hasOwnProperty('TENANT_APP_DEFAULTS_PARAM')
        },
        mainDataLoaded: function(){
            let response = this.merchant.hasOwnProperty('application_external_id') && this.quote.hasOwnProperty('quote_external_id')
            // console.log('Application and Quote Data Loaded : ',response)
            return response
        },
        allowMoreBanks: function(){
            let target_index = this.outlet.banks.length - 1
            // console.log('residual', this.residualAccountTypes)
            // console.log('module ', this.outlet.banks.length, this.residualAccountTypes.length, target_index)
            // console.log('-------->', this.residualAccountTypes)

            if(!!this.residualAccountTypes && this.residualAccountTypes.length === 0)
            {
                return false
            }
            // if(this.outlet.banks.length === this.residualAccountTypes.length){
            //     return true
            // }
            // else if(this.residualAccountTypes.length < target_index )
            // {
            //     return false
            // }
            // else if(this.residualAccountTypes[target_index].length > 0)
            // {
            //     return false
            // }
            return true //!(this.outlet.banks.length === this.residualAccountTypes.length)
        },
        allianceCountry: function() {
            return defaultCountry;
        },
        searchOnPolandDisabled: function(){
            let vm = this;
            //console.log('searchOnPolandDisabled:=>', vm.allianceCountry);
            return vm.getIso3FromCountryCode( vm.allianceCountry ) === 'POL';
        },
        disableLegalNameSearchForCountry: function(){
            let vm = this;
            let countries = ['POL', 'SWE', 'NOR'];
            let checkBusinessType = (this.merchant.ownership_entity_type === this.business_types.JOINT_STOCK_COMPANY || this.merchant.ownership_entity_type === this.business_types.PARTNERSHIP);
            return (countries.includes(vm.getIso3FromCountryCode( vm.allianceCountry )) && checkBusinessType);
        },
        allowLegalNameSearch : function(){
            let vm = this;
            switch (vm.baseCountryCode) {
                case '826': //uk
                    return vm.isQuoteLimited || vm.isQuotePartnershipLLP;
                case '372': //Ireland
                    return vm.isQuoteLimited || vm.isQuotePartnershipLLP;
                case '616': //Poland
                    return false;
                case '752': //Sweden
                    return false;
                case '276': //Germany
                    return vm.isQuoteLimited || vm.isQuotePartnershipLLP;
                default:
                    return false;
            }
        },
    },
    methods: {
        ...mapActions(useApplicationStore ,[types.COMMIT_APPLICATION, types.INITIATE_QUOTE, types.UPDATE_QUOTE,
            types.CONVERT_QUOTE, types.CONVERT_PUBLIC_QUOTE, types.CREATE_QUOTE_MERCHANT_USER, types.SAVE_MERCHANT,
            types.SAVE_BANK_ID_PRINCIPAL_DATA, types.SAVE_OUTLET, types.FETCH_QUOTE_DATA]),
        ...mapActions(useApplicationStore, [types.SET_APPLICATION_PAGE_TITLE,
            types.SET_APPLICATION_ROOT_PATH,
            types.SET_QUOTE_ROOT_PATH, types.UNMASK_PII_DATA,
            types.COMMIT_OUTLETS, types.SET_GO_BACK_WARNING_MODAL]),
        setQuoteOfferByOutlet: function (payload, offer_type){
            if (payload.length > 0) {
                if (offer_type === 'online') {
                    this.quote['online_offer'] = payload[0];
                }
                if (offer_type === 'equipment') {
                    this.quote['equipment_offer'] = payload[0];
                }

                this.quote_offer_updated_by_outlet = true;
            }
        },
        formatNumberByLocale: function (number, decimal = 2, style = 'decimal', currency = ''){
            let vm = this;
            let locale = 'en-GB';
            let options = {style: style,  minimumFractionDigits: decimal, maximumFractionDigits: decimal};
            let needs_currency_format = '';

            if (vm.objectIsNotEmpty(vm.alliance)) {

                let partner = vm.getPartner();

                if (!!partner && !!partner.default_language) {
                    let lang = partner.default_language.split('_');
                    locale = `${lang[0]}-${lang[1].toUpperCase()}`;
                }
                else if (!!vm.alliance.default_language) {
                    let lang = vm.alliance.default_language.split('_');
                    locale = `${lang[0]}-${lang[1].toUpperCase()}`;
                }
                // Changes the numbers format when Alliance is Sweden
                if (!!partner && !!partner.default_currency) {
                    if (vm.default_currencies_to_format.hasOwnProperty(partner.default_currency)) {
                        locale = vm.default_currencies_to_format[partner.default_currency].locale;
                        needs_currency_format = partner.default_currency;
                    }
                }
                else if (!!vm.alliance.default_currency) {
                    if (vm.default_currencies_to_format.hasOwnProperty(vm.alliance.default_currency)) {
                        locale = vm.default_currencies_to_format[vm.alliance.default_currency].locale;
                        needs_currency_format = vm.alliance.default_currency;
                    }
                }
            }

            if (style === 'currency'){
                //currency could be sent in the function or come from the alliance default currency
                options.currency = !!currency ? currency : defaultCurrency
            }

            let result = new Intl.NumberFormat(locale, options).format(number);

            // Changes the numbers format when Alliance is Sweden or Norway
            if (!!needs_currency_format && vm.default_currencies_to_format.hasOwnProperty(needs_currency_format)) {
                result = result.replace(vm.default_currencies_to_format[needs_currency_format].search_value, vm.default_currencies_to_format[needs_currency_format].replace_value);
            }

            return result;
        },
        checkDestinationRoute: function (to, from){
            let vm = this, to_step = '';
            let findTabIndex = (path) => {
              return vm.application_tabs.findIndex((tab, index) => {
                    // return if tab path match or subitem path matchs
                    return tab.url === path || (vm.npPropertyExistAndIsArray(tab, 'subitems')
                        && (tab.subitems.findIndex(subitem => {return subitem.url === path}) > -1))
                })
            }

            let index_to = findTabIndex(to.fullPath);
            let index_from = findTabIndex(from.fullPath);

            if (index_from === -1){ //might be missing a trailing slash
                index_from = findTabIndex(from.fullPath + '/');
            }

            //if you are moving in the same step
            //sometimes the url is wrong. so the -1 check is added
            if (index_to === index_from && index_to != '-1'){
                index_to = vm.application_tabs[index_to].subitems.findIndex(sub => {return sub.url === to.fullPath})
                index_from = vm.application_tabs[index_from].subitems.findIndex(sub => {return sub.url === from.fullPath})
            }
            //if going to home, index_to will be -1
            return index_to > index_from  //if true, then we have to validate, else don't validate
        },
        formHasValues: function ($formElement){
            let formData = this.getFormData($formElement);
            let has_value = false;
            for (let value in formData) {
                if (formData.hasOwnProperty(value)) {
                    if(formData[value] !== ''){
                        has_value = true;
                        break;
                    }
                }
            }
            return has_value
        },
        alertBackRouteWarning: function (callback = null){
            let vm = this;
            this.$swal({
                title: this.lang('are_you_sure'),
                text: this.lang('you_will_lose_unsaved_changes'),
                icon: "warning",
                confirmButtonColor: '#e64942',
                showCancelButton: true,
                showDenyButton: true,
                denyButtonText: this.lang('ok_and_disable_warning'),
                confirmButtonText: this.lang('ok'),
                cancelButtonText:this.lang('cancel'),
                customClass: {
                    cancelButton: 'order-1',
                    confirmButton: 'order-2',
                    denyButton: 'order-3',
                },
                dangerMode: true,
            }).then((goBack) => {
                if (!!goBack.value || goBack.isDenied) {
                    if (goBack.isDenied){
                        vm[types.SET_GO_BACK_WARNING_MODAL](true);
                    }
                    callback()
                    return;
                }else {
                    callback(false)
                }
            }).catch(() => {
                callback(false);
            });
        },
        revertContinueButton: function (){
            setTimeout(() => {this.disableContinueBtn = false} ,3000)
        },
        isEquipment: function (bundle_item) {
            return !!this.objectIsNotEmpty(bundle_item.equipment) && !this.objectIsNotEmpty(bundle_item.service) && bundle_item.equipment.equipment_pos_type !== ACCESSORY
        },
        isAccessory: function (bundle_item){
            return !!this.objectIsNotEmpty(bundle_item.equipment) && bundle_item.equipment.equipment_pos_type === ACCESSORY
        },
        formatFieldDays: function (value){
            if (!!value){
                return value + ' ' + this.lang('days');
            }
            return '-';
        },
        formatFieldPerc: function (value){
            if (!!value){
                return value +  '%';
            }
            return '-';
        },
        checkPricingIsSelected: function (pricingObject){
            let is_valid = false;
            if (!!pricingObject && pricingObject.hasOwnProperty('charge_items')) {
                is_valid = pricingObject.charge_items.some(charge => {
                    //ensure they have selected a pricing that is visible on the UI
                    return charge.is_boarding_activated == '1' && charge.is_invisible == '0';
                })
            }
            return is_valid;
        },
        isAcquiringOnlyEquipmentOffer:function (equipment_offer) {
            return !!equipment_offer && equipment_offer.acquiring_only === '1';
        },
        setQuoteRootPath: function (id, action = 'view') {
            let root_path = '';
            //check if it is application/add
            if (window.location.pathname.includes('/application/add/')) {
                root_path = '/application/add/';
            } else {
                root_path = '/quote/' + action + '/' + id + '/';
                // redirect to view
                //this bit causing problems for merchant to upload while merchant control 0 aka, quote locked on submission, waiting for doc upload
                //console.log('quote root, merchant upload', this.merchantToUpload)
                if (this.isLockedQuote && action === 'edit' && !this.merchantToUpload) {
                    location.href =  '/quote/view/' + id + '/business/';
                }
            }
            this[types.SET_QUOTE_ROOT_PATH](root_path)
        },
        setApplicationRootPath: function (id, action= 'view') {
            let root_path = '';
            //check if it is application/add
            if (window.location.pathname.includes('/application/add/')) {
                root_path = '/application/add/';
            } else {
                root_path = '/application/' + action + '/' + id + '/';
                // redirect to view
                if (!this.isOpenApplication && action === 'edit') {
                    //if user goes back from signing on elavon page, they should redirect to the review page. ELT-787
                    if (window.location.pathname.includes('review')) {
                        location.href = '/application/view/' + id + '/review/';
                    }
                    else {
                        location.href = '/application/view/' + id + '/business_details/';
                    }
                }
            }

            this[types.SET_APPLICATION_ROOT_PATH](root_path)
        },
        setAppPageTitle: function (value){
            useApplicationStore()[types.SET_APPLICATION_PAGE_TITLE] (value);
            //this.$store.commit(types.SET_APPLICATION_MODULE + types.SET_APPLICATION_PAGE_TITLE, value);
        },
        setOtherTitle: function (data, reverse = false, is_principal = false) {
            let title_key = is_principal ? 'owner_title' : 'contact_title';
            let other_title_key = is_principal ? 'other_owner_title' : 'other_contact_title';

            //check if contact title is in primary titles, if not set contact_title to 'other' to show the more titles
            if (!!data[title_key] && !this.primary_titles.includes(data[title_key])) {
                if (!reverse){ //edit pages
                    let is_valid_other_title = Array.isArray(this.otherTitles) && this.otherTitles.some(title => title.id === data[title_key]);
                    if (is_valid_other_title) {
                        data[other_title_key] = data[title_key];
                        data[title_key] = 'other';
                    }
                }else{//view pages
                    data[title_key] = !!data[other_title_key] && data[other_title_key] !== 'other'
                        ? data[other_title_key] : data[title_key];
                }
            }
        },
        isMerchantViewAndUpdateDocument: function (unfinished_application) {
            let merchant_to_upload_document = !!unfinished_application
                && unfinished_application.hasOwnProperty('merchant_to_upload_document')
                && unfinished_application.merchant_to_upload_document === '1';
            let merchant_in_control = !!unfinished_application
                && unfinished_application.hasOwnProperty('merchant_control')
                && unfinished_application.merchant_control === '1';

            return merchant_to_upload_document && !merchant_in_control;
        },
        isBankIdWorkflowConfigured: function () {
            let parameters = vue_data && vue_data.hasOwnProperty('parameters') ? vue_data.parameters : null;
            if (parameters.hasOwnProperty('APPLICATION_PROCESS_ACTIONS_CHECK') && !!parameters.APPLICATION_PROCESS_ACTIONS_CHECK) {
                let workflow_actions = parameters.APPLICATION_PROCESS_ACTIONS_CHECK;
                return workflow_actions.BANK_ID_VERIFICATION === true;
            }
            return false;
        },
        editAddress: function (){
            this.edit_address = true;
            this.allow_manual_edit = false;
        },
        searchByLegalName() {
            const component = this.$refs['company-search'];
            component.show();
            component.searchByCompanyName();
        },
        searchByRegNumber() {
            const component = this.$refs['company-search'];
            component.show();
            component.searchByRegNumber();
            // Logic removed from frontend because it causes the fields to go out of sync, server already handles this.
            // if (!!this.quote && this.merchant.reg_number) {
            //     this.quote['reg_number'] = this.merchant.reg_number
            // }
        },
        searchByVatNumber() {
            const component = this.$refs['company-search'];
            component.show();
            component.searchByVatNumber(this.merchant.tax_id);
        },
        //DO NOT USE. Use updateCompanyAddress instead.
        // updateAddress: function (data, address) {
        //     address.zip_code = data.postcode;
        //     address.street_number = data.street_number;
        //     address.floor = data.floor;
        //     address.suite_apart_number = data.suite_apart_number;
        //     address.flat_name = data.flat_name;
        //     address.house_name = data.buildingName;
        //     address.house_number = data.buildingNumber;
        //     address.street_line_1 = data.street;
        //     address.locality = data.locality ;
        //     address.city = data.city;
        //     address.province = data.province ? data.province: '';
        //     address.county_code = data.county;
        //     address.country_code = '826';
        // },
        processCompanySearchData: function (data, companyObject  = {}) {
            const companyDetails = data.companyDetails;
            let vm = this, field_keys = [];
            companyObject = this.objectIsNotEmpty(companyObject) ? companyObject: vm.merchant;
            companyDetails.forEach(d => {
                let value = !!d.value ? d.value : ''; //d.value may be undefined.
                switch (d.key) {
                    case 'legal_name':
                        if (!!d.value) {
                            value = value.replaceAll('"', '');
                            companyObject['legal_name'] = value;
                        }
                        break;
                    case 'business_type':
                        let ownership_entity_type = vm.getOwnershipEntityType(value, companyObject.legal_name);
                        if (!!ownership_entity_type) {
                            companyObject['ownership_entity_type'] = ownership_entity_type;
                        }
                        break;
                    case 'reg_no' || 'reg_number':
                        if (!!d.value) {
                            //value minlength below append 00s
                            let min_length = vm.getRegNoFieldLengthByIso3 ( vm.getIso3FromCountryCode( vm.baseCountryCode ), 'min')
                            let newValue = value.toString()
                            if(newValue.length > 1){
                                while(newValue.length < min_length){
                                    newValue = '0' + newValue
                                }
                            }
                            companyObject[vm.isCharity ? 'reg_charity_number' : 'reg_number'] = newValue;
                        }
                        break;
                    case 'vat_no' || 'vat_number':
                        if (!!d.value) {
                            companyObject['int_tax_exempt_flag'] = '1'
                            let vat_no = d.value;
                            //Sweden VAT numbers from Bisnode return SExxxxxxxxxxxxx that TGW can't validate and exceeds 12 characters
                            //interim solution, remove SE
                            if (vm.allianceCountry === '752') {
                                vat_no = vat_no.replace(/SE/g, '');
                            }
                            companyObject['tax_id'] = vat_no;
                        }
                        break;
                    case 'date_incorporation' || 'incorporation_date':
                        if (!!d.value) {
                            companyObject['date_incorporated'] = value;
                        }
                        break;
                    case 'reg_web':
                        if (!!d.value) {
                            companyObject['business_website'] = value;
                        }
                        break;
                    // case 'reg_web':
                    //     vm.merchant['website'] = d.value;
                    //     break;
                }

                //get the fields for the validation
                field_keys.push(d.key)
            });

            this.runValidationOnFieldChange(field_keys)

            if (data.address) {
                this.updateCompanyAddress(data.address, companyObject.registration_address);
            }
            else if (data.registered_address) {
                this.updateCompanyAddress(data.registered_address, companyObject.registration_address);
            }

            if (!!companyObject.registration_address) {
                let addressMap = {
                    zip_code: 'zip_code',
                    house_number: 'house_number',
                    house_name: 'house_name',
                    street_line_1: 'street_line_1',
                    street_line_2: 'street_line_2',
                    city: 'city',
                    county_code: 'county_code',
                    country_code: 'country_code',
                };
                Object.entries(addressMap).forEach(([key, value]) => {
                    //last check to avoid teh data has an empty space as value
                    if(companyObject.registration_address.hasOwnProperty(value) && !!companyObject.registration_address[value]) {
                        companyObject[key] = companyObject.registration_address[value];
                    }
                });
            }
        },
        changedPostcode: function (addressObject){
            //addressObject['street_line_1'] = '';
            addressObject['search_postcode'] = true;
        },
        changedAddressFinderSearch: function (addressObject){
            //addressObject['street_line_1'] = '';
        },
        processPersonnelSearchData: function (data, personnelObject = {}) {
            const shareholder = Object.assign(data.shareholder, data.shareholder.details);
            let principal = this.owners[this.current_index], vm = this, principal_keys =[];

            let keyMap = {
                owner_title: 'title',
                owner_first_name: 'first_name',
                owner_second_name: 'middle_name',
                owner_surname: 'last_name',
                contact_dob: 'date_of_birth',
                owner_nationality: 'nationality',
                // owner_position: 'position',
                ownership_perc: 'percentage_of_shares',
                email_address: '',
                // owner_alt_phone_no: '',
                // owner_alt_phone_code: defaultPhoneCode,
                owner_phone_no: '',
                owner_phone_code: defaultPhoneCode,
                zip_code: 'address',
                house_name: '',
                house_number: '',
                flat_name: '',
                flat_number: '',
                street_line_1: '',
                locality: '',
                city: '',
                county_code: '',
                // country_code: defaultCountry
            };

            Object.keys(keyMap).forEach(d => {
                if (keyMap[d] !== '' && shareholder.hasOwnProperty(keyMap[d])) {
                    if (d === 'zip_code') {
                        principal.contacts[0][d] = shareholder[keyMap[d]]['postcode'];

                        //ask user to search postcode
                        principal.contacts[0]['street_line_1'] = '';
                        principal.contacts[0]['search_postcode'] = true;
                        // this.updateCompanyAddress(data.address, personnelObject.contacts[0]);
                        // let country_iso2 = !!shareholder[keyMap[d]]['country_code'] ? shareholder[keyMap[d]]['country_code'] : '';
                        // let country_code = vm.getCountryNumCodeFromIso2(country_iso2);
                        // principal['country_code'] = country_code;
                        let zip_code = !!shareholder[keyMap[d]]['postcode'] ? shareholder[keyMap[d]]['postcode'] : '';
                        // principal['zip_code'] = zip_code;
                        if (!!zip_code) {
                            let postcodeElement = vm.$refs['zip_code'][vm.current_index];
                            postcodeElement.search(zip_code);
                        }
                        // else {
                        //     let street = !!shareholder[keyMap[d]]['address_line1'] ? shareholder[keyMap[d]]['address_line1'] : '',
                        //         county_code = !!shareholder[keyMap[d]]['county'] ? shareholder[keyMap[d]]['county'] : '',
                        //         city = !!shareholder[keyMap[d]]['city'] ? shareholder[keyMap[d]]['city'] : ''
                        //     principal['county_code'] = county_code;
                        //     principal['city'] = city;
                        //     principal['street_line_1'] = street;
                        //
                        // }
                    } else if (d === 'contact_dob') {
                        let contact_dob = (!!shareholder[keyMap[d]] ? shareholder[keyMap[d]] : '');
                        // let contact_dob = (!!shareholder[keyMap[d]] ? shareholder[keyMap[d]] : '').split('-');
                        // let dob = `01-${contact_dob[1]}-${contact_dob[0]}`;
                        const date_format_mapping = {
                            ddmmyyyy: 'DD-MM-YYYY',
                            mmddyyyy: 'MM-DD-YYYY',
                            yyyymmdd: 'YYYY-MM-DD'
                        }

                        const tenant_format = $('body').attr('data-date-format')
                        const parsedDate = moment(contact_dob, date_format_mapping['ddmmyyyy']);
                        const formatted_contact_dob = parsedDate.format(date_format_mapping[tenant_format]);

                        principal[d] = formatted_contact_dob;
                    } else if (d === 'owner_title') {
                        let value = shareholder[keyMap[d]] !== '' ? `${shareholder[keyMap[d]]}.` : '';

                        if (value !== '') {
                            let title = this.primeTitles.find(obj => {
                                return obj.id === value
                            });

                            //check if the value is part of the prime titles in the radios.
                            if (!title) {
                                principal[d] = 'other';
                                principal['other_owner_title'] = value;
                            } else {
                                principal[d] = `${shareholder[keyMap[d]]}.`;
                            }
                        }

                    } else if (d === 'owner_nationality') {
                        let country_iso2 = !!shareholder[keyMap[d]] ? shareholder[keyMap[d]] : 'GB';
                        // //console.log(country_iso2)
                        let country_code = vm.getCountryNumCodeFromNationality(country_iso2);
                        principal[d] = country_code;
                    } else if (d === 'owner_first_name') {
                        let first_name = shareholder[keyMap[d]].split(" ");
                        if (first_name.length > 0) {
                            principal[d] = first_name[0];
                        }
                    } else {
                        principal[d] = shareholder[keyMap[d]];
                    }
                } else if (d === 'owner_second_name') {
                    if (!!shareholder[keyMap['owner_first_name']] && !shareholder[keyMap[d]]) {
                        let middle_name = this.getMiddleName(shareholder[keyMap['owner_first_name']]);
                        principal[d] = !!middle_name ? middle_name : '';
                    }
                } else {
                    if (d === 'owner_phone_code' || d === 'owner_alt_phone_code') {
                        principal[d] = defaultPhoneCode;
                    }
                    else if (d === 'owner_nationality') {
                        principal[d] = defaultCountry;
                    }
                    else if (d === 'ownership_perc') {
                        if (vm.merchant && (vm.merchant.ownership_entity_type === vm.business_types.SOLE_TRADER)) {
                            //skip
                        }
                    }
                    else if (d === 'owner_second_name') {
                        if (!!shareholder[keyMap['owner_first_name']] && !shareholder[keyMap[d]]) {
                            let middle_name = this.getMiddleName(shareholder[keyMap['owner_first_name']]);
                            principal[d] = !!middle_name ? middle_name : '';
                        }
                    }
                    else {
                        principal[d] = '';
                    }
                }

                //get the fields for the validation
                principal_keys.push(d + '_'+ this.current_index)
            });
            // this.runValidationOnFieldChange(principal_keys)
        },
        getMiddleName: function (owner_first_name) {
            let middle_name = '';
            if (!!owner_first_name) {
                let splitted_fname_array = owner_first_name.split(/ (.*)/,2);
                if (splitted_fname_array.length > 0) {
                    middle_name = splitted_fname_array[1];
                }
            }
            return middle_name;
        },
        getCountryNumCodeFromNationality: function (data){
            let countries = !!this.parameters.COUNTRIES_PARAM ? this.parameters.COUNTRIES_PARAM : [];
            let numcode = '';
            if (data !== '') {
                let entry = countries.find(obj => {
                    return !!obj.nationality && obj.nationality == data
                });
                numcode = !!entry ? entry.numcode : ''
            }
            return numcode;
        },
        getCountryNumCodeFromIso2: function (country_iso2) {
            let countries = !!this.parameters.COUNTRIES_PARAM ? this.parameters.COUNTRIES_PARAM : [];
            let numcode = '';
            if (country_iso2 != '') {
                let entry = countries.find(obj => {
                    return !!obj.iso2 && obj.iso2 == country_iso2
                });
                numcode = !!entry ? entry.numcode : ''
            }
            return numcode;
        },
        returnDifferenceBetweenUKDates: function (date_from, date_to) {
            if (!date_from) {
                return 0;
            }
            let dateTo = !!date_to ? new Date(this.convert_uk_date_to_iso(date_to)).getTime() : new Date().getTime();
            let dateFrom = new Date(this.convert_uk_date_to_iso(date_from)).getTime();

            return Math.round((dateTo - dateFrom) / this.dayInMilliseconds);
        },
        convert_uk_date_to_iso: function (string) { //accept string DD-MM-YYYYY
            let arr = string.split('-');
            return arr[2] + '-' + arr[1] + '-' + arr[0];
        },
        allowManualEdit: function () {
            this.allow_manual_edit = true;
        },
        updateCompanyAddress: function (data, addressObject = {}, isAddressFinder = false) {
            if (!!data) {
                this.edit_address = false;
                let address_keys = [];
                //TODO if user has entered building number and postcode is selected, don't overwrite building number.
                // still tricky how to distinguish user entry from search ...
                let addressMap = {
                    zip_code: 'postcode',
                    street_number: 'street_number',
                    floor: 'floor',
                    suite_apart_number: 'suite_apart_number',
                    house_name: 'building_name',
                    house_number: 'building_number', //this prevents overwriting the building number
                    street_line_1: 'street',
                    flat_name: 'flat_name',
                    locality: 'locality',
                    city: 'city',
                    county_code: 'county',
                };
                Object.entries(addressMap).forEach(([key, value]) => {
                    //last check to avoid teh data has an empty space as value
                    //TODO last check might fall, better option would be !!data[value].toString().trim()
                    if(data.hasOwnProperty(value) && !!data[value] && !!data[value].toString().trim()) {
                        if (!this.objectIsNotEmpty(addressObject)) {
                            addressObject = new Contact();
                        }
                        addressObject[key] = data[value];

                        //get the fields for the validation
                        address_keys.push(key)
                    } else {
                        addressObject[key] = '';
                    }
                });
                //for postcodes without street data
                if (addressObject.street_line_1 === ''){
                    if (!!data['address_line1']){
                    addressObject.street_line_1 = data['address_line1'];
                    }else{
                        // if street
                        this.editAddress()
                    }
                }

                // remove space for sweden alliance postcodes - 752
                if (addressObject.hasOwnProperty('country_code') && addressObject.country_code === '752' && addressObject.hasOwnProperty('zip_code') && addressObject.zip_code !== "") {
                    addressObject.zip_code = addressObject.zip_code.replace(" ", "")
                }

                // for Norway, ignore the city value and use county
                let countries_change_city_to_county = ['578'];
                if (countries_change_city_to_county.includes(addressObject.country_code) && !!data['county']) {
                    addressObject.city = data['county'];
                }

                addressObject.country_code = data.country_code ? this.getCountryNumCodeFromIso3(data.country_code) : this.baseCountryCode;

                //remove message for user to search postcode
                addressObject.search_postcode = false;

                // clear address finder
                if (isAddressFinder && addressObject.address_finder) {
                    addressObject.address_finder = '';
                }

                this.runValidationOnFieldChange(address_keys)
            }
        },
        getOwnershipEntityType(type, name) {
            let ownership_entity_type = '', vm = this, business_type = type.toLowerCase(),
                legal_name = name.toLowerCase();

            if (business_type.includes('limited') || business_type.includes('private') || business_type.includes('ltd') || business_type.includes('plc')) {
                ownership_entity_type = vm.business_types.LIMITED;
            }
            if (business_type.includes('public')) {
                ownership_entity_type = vm.business_types.PUBLIC_LIMITED_COMPANY;
            }
            if (business_type.includes('partner')) {
                ownership_entity_type = vm.business_types.PARTNERSHIP;
            }
            if (business_type.includes('sole')) {
                ownership_entity_type = vm.business_types.SOLE_TRADER;
            }
            if (business_type.includes('liability') || business_type.includes('llp') || (business_type.includes('limited') && business_type.includes('partner'))) {
                let found = !!vm.paramBusinessTypeSB ? vm.paramBusinessTypeSB.find((obj) => {return obj.id === vm.business_types.LIMITED_LIABILITY_PARTNERSHIP}) : null
                ownership_entity_type = (found) ? vm.business_types.LIMITED_LIABILITY_PARTNERSHIP : vm.business_types.LIMITED
            }
            if (business_type.includes('limited') && business_type.includes('exempt from using "limited"')) {
                if (legal_name.includes('charity')) {
                    ownership_entity_type = vm.business_types.CHARITY;
                }
                if (legal_name.includes('trust')) {
                    ownership_entity_type = vm.business_types.TRUST;
                }
                if (legal_name.includes('club')) {
                    ownership_entity_type = vm.business_types.CLUB;
                }
                if (legal_name.includes('society')) {
                    ownership_entity_type = vm.business_types.SOCIETY;
                }
            }

            return ownership_entity_type;
        },
        getFormData($form) {
            var unindexed_array = $form.serializeArray();
            var indexed_array = {};

            $.map(unindexed_array, function (n, i) {
                indexed_array[n['name']] = n['value'];
            });

            return indexed_array;
        },
        getPrincipalFullName: function (owner){
            let first_name = !!owner.owner_first_name ? owner.owner_first_name + ' ' :'';
            let surname = !!owner.owner_surname ? owner.owner_surname :'';
            return first_name + surname;
        },
        removeAddress: function (owner, index) {
            // this.setApplicationSave();
            owner.contacts.splice(index, 1);
        },
        removeSlashes: function (data, index, field) {
            let regex = /[/]/g;
            field === 'contact_dob' ? this.owners[index].contact_dob = data.replace(regex, '-') : '';
        },
        doApplicationSave(to_path=null) {
            if (this.validateAppForm()){
                let form = this.getFormData($('#form'));
                let payload = {}, ajax_url = '', section = form.section;
                if (section === 'PRINCIPAL') {
                    payload = this.merchant.owners;
                } else if (section === 'OUTLET_INFORMATION') {
                    payload = this.outlets[0];
                } else if (section === 'BUSINESS_OUTLET_BANK') {
                    payload = {
                        ...form, ...{
                            application_external_id: this.merchant.application_external_id,
                            alliance_external_id: this.merchant.alliance_external_id,
                            banks: this.outlet.banks,
                            outlet_external_id: this.outlet.outlet_external_id
                        }
                    };
                } else {
                    payload = {
                        ...form, ...{
                            application_external_id: this.merchant.application_external_id,
                            alliance_external_id: this.merchant.alliance_external_id,
                        }
                    };
                }
                // if (this.merchant.application_external_id !== '') {
                ajax_url = section === 'OUTLET_INFORMATION' ? 'ajaxupdateoutlet' : 'ajaxsavemerchant'
                // } else {
                //     ajax_url = 'ajaxsaveapplication'; //will create new application
                // }

                //TODO change to the right reference
                let reference = !!this.merchant.application_reference ? this.merchant.application_reference : this.merchant.merchant_reference;
                const url = `/application/${ajax_url}/${reference}/${section}`;
                payload.section = section

                return this.getAxiosInstance().post(url, payload).then(response => {
                    if (response['data']['result'] === 'SUCCESS') {

                        if(!response.data.section) response.data.section = section
                        if(!response.data.outlets && !!response.data.outlet) response.data.outlets = [response.data.outlet]

                        const {application, outlets} = response.data;
                        if (!!outlets) {
                            if (section === 'PRINCIPAL') {
                                this.merchant.owners = response.data.application.owners;
                            } else {
                                this[types.COMMIT_OUTLETS](response.data);
                            }
                        }
                        this.notifySuccess(this.lang('application_updated_successfully'));
                        if(!to_path) this.nextPage(to_path);
                        else this.nextPage()
                        return true;
                    }
                    else
                    {
                        return false;
                    }
                });

            }
            else {
                return false;
            }
        },
        nextPage: function(to_path) {
            this.$router.push({path: to_path});
        },
        signatoryEmailMatchesUser: function(owner){
            if (owner.is_signatory === '1'){
                return owner.owner_email === this.user.email
            }
            return true;
        },
        addressIsValid: function (addressObject){
            let is_valid = true;
            if (this.countCharacters(addressObject.street_line_1)  === 0 || this.countCharacters(addressObject.street_line_1)  === 0 ||
                this.countCharacters(addressObject.country_code)  === 0 || this.countCharacters(addressObject.country_code)  === 0 ||
                (this.countCharacters(addressObject.house_name)  === 0 && this.countCharacters(addressObject.house_number)  === 0)){
                is_valid = false;
            }
            return is_valid;
        },
        validateAppForm: function () {
            //open all accordions before validating. Accordions don't validate nicely when closed.
            $('[id^=heading_]').removeClass('collapsed')
            $('[id^=collapse_]').addClass('show');

            const validate_form = this.validateForm('#form');

            let form = this.getFormData($('#form')), section = form.section;
            if (section === 'BUSINESS_OUTLET_BANK'){
                //validate address
                let is_valid_address = this.addressIsValid(this.merchant.registration_address);

                //validate bank
                let is_valid_bank = this.outlet.banks[0].is_valid === '1';

                //TODO save for later when ELavon fix their API
                // validate  incorporation date one month or more
                // let is_valid_incorp_date = moment().diff(moment(this.merchant.date_incorporated, 'DD-MM-YYYY'), 'months') > 0;

                if (!is_valid_bank) {
                    this.notifyError(this.lang('validation_error'), this.lang('bank_details_are_invalid'))
                }

                if (!is_valid_address) {
                    if (this.countCharacters(this.merchant.registration_address.house_name) === 0 && this.countCharacters(this.merchant.registration_address.house_number) === 0) {
                        this.setHasErrorClassOnField(['house_name', 'house_number'])

                        this.notifyError(this.lang('validation_error'), this.lang('validation_house_name_number_is_required'))
                    }

                    this.notifyError(this.lang('validation_error'), this.lang('validation_postcode_search'));
                }

                // if (!is_valid_incorp_date) {
                //     this.notifyError(this.lang('validation_error'), this.lang('validation_business_incorp_date'));
                // }

                if (!is_valid_bank || !is_valid_address) {
                    return false;
                }

            }else if (section === 'PRINCIPAL'){
                //TODO WHEN ELAVON is sure we will re-implement ELT-201. Code has mostly been done so check 4-09-2020
                //owner type check.
                let is_valid_signatory = this.merchant.owners.some(obj => {return obj.is_signatory === '1'});
                let is_valid_main_principal = this.merchant.owners.some(obj => {return obj.is_main_principal === '1'});
                let is_valid_beneficial_owner = this.merchant.owners.some(obj => {return obj.is_beneficial_owner === '1'});
                let is_valid_owner = this.merchant.owners.some(obj => {return obj.is_owner === '1'});
                let is_valid_director = this.merchant.owners.some(obj => {return obj.is_director === '1'});
                let is_valid_responsible_party = this.merchant.owners.some(obj => {return obj.is_responsible_party === '1'});

                let owner_has_position = true, partnership_errors = [], validation_errors = [], position_errors = [];

                if (this.partnershipBusinessTypes.includes(this.merchant.ownership_entity_type)) {
                    //DEPRECATED partnership can have one principal
                    // Check director length
                    // if (this.merchant.owners.length < 2) {
                    //     partnership_errors.push(this.lang('validation_partnership_business_less_than_two_owners'));
                    // }

                    let has_sole_owner = this.merchant.owners.some(obj => {return parseFloat(obj.ownership_perc) === 100});
                    if (has_sole_owner) {
                        partnership_errors.push(this.lang('validation_partnership_business_with_100'));
                    }
                }

                //address type check
                let is_valid_address = true, address_errors =  [], dob_errors = [];
                this.merchant.owners.forEach((owner, index) => {
                    let fullname = this.getPrincipalFullName(owner)
                    if (!this.addressIsValid(owner.contacts[0])){
                        is_valid_address = false;

                        if (this.countCharacters(owner.contacts[0].house_name) === 0 || this.countCharacters(owner.contacts[0].house_number) === 0) {
                            this.setHasErrorClassOnField(['house_name_'+index, 'house_number_'+index])

                            address_errors.push(`${this.lang('validation_house_name_number_is_required')} for ${this.lang('principal')} ${fullname}`)
                        }

                        address_errors.push(`${this.lang('validation_postcode_search')} for ${this.lang('principal')} ${fullname}`)
                    }

                    //dob check
                    let dob_diff = moment().diff(moment(owner.contact_dob, 'DD-MM-YYYY'), 'years') > 17;
                    if (!dob_diff){
                        dob_errors.push(`${this.lang('principal')} ${fullname} ${this.lang('validation_principal_dob')}`)
                    }

                    //ownership position
                    if(owner.is_signatory !== '1' && owner.is_beneficial_owner !== '1' && owner.is_director !== '1'){
                        owner_has_position = false;
                        position_errors.push(`${this.lang('principal')} ${fullname} ${this.lang('validation_principal_position')}`)
                    }

                    //validate signatory owner email to match user email
                    if (owner.is_signatory === '1' && !this.signatoryEmailMatchesUser(owner)) {
                        position_errors.push(`${this.lang('principal')} ${fullname} ${this.lang('validation_signatory_principal_email_error')}`)
                    }
                });

                // Name check
                let strArray = this.merchant.owners.map(own => {return `${own.owner_first_name} ${own.owner_second_name} ${own.owner_surname}`});
                let strEmailArray = this.merchant.owners.map(own => {return `${own.owner_email}`});
                let findDuplicates = arr => arr.filter((item, index) => item !== '' && arr.indexOf(item) != index) //first check prevents error on two empty email fields

                let duplicate_names = [...new Set(findDuplicates(strArray))]; // All duplicates
                let duplicate_emails = [...new Set(findDuplicates(strEmailArray))]; // All duplicates

                if (!is_valid_owner) {
                    validation_errors.push(this.lang('one_owner'))
                }
                if (!is_valid_signatory) {
                    validation_errors.push(this.lang('one_signatory'))
                }
                if (!is_valid_beneficial_owner) {
                    validation_errors.push(this.lang('one_beneficial_owner'))
                }
                if (!is_valid_main_principal) {
                    validation_errors.push(this.lang('one_main_principal'))
                }
                if (!is_valid_director) {
                    validation_errors.push(this.lang('one_director'))
                }
                if (!is_valid_responsible_party) {
                    validation_errors.push(this.lang('one_responsible_party'))
                }

                if (validation_errors.length > 0
                    || partnership_errors.length > 0
                    || address_errors.length > 0
                    || duplicate_names.length > 0
                    || duplicate_emails.length > 0
                    || dob_errors.length > 0
                    || position_errors.length > 0) {
                    let message = this.lang('select_at_least');
                    let validation_start = validation_errors.slice(0, -2);
                    let validation_end = validation_errors.slice(-2);
                    if (validation_errors.length <= 2) {
                        message += validation_end.join(` ${this.lang('and')} `);
                    } else {
                        message += validation_start.join(`, `) + ', ';
                        message += validation_end.join(` & `);
                    }

                    if (address_errors.length > 0) {
                        address_errors.forEach(obj => {
                            this.notifyError(this.lang('validation_error'), obj);
                        })
                    }
                    if (dob_errors.length > 0) {
                        dob_errors.forEach(obj => {
                            this.notifyError(this.lang('validation_error'), obj);
                        })
                    }
                    if (position_errors.length > 0) {
                        position_errors.forEach(obj => {
                            this.notifyError(this.lang('validation_error'), obj);
                        })
                    }
                    if (duplicate_names.length > 0) {
                        this.notifyError(this.lang('validation_error'), `${this.lang('validate_duplicate_names')}: ${duplicate_names.join(', ')}`);
                    }
                    if (duplicate_emails.length > 0) {
                        this.notifyError(this.lang('validation_error'), `${this.lang('validate_duplicate_emails')}: ${duplicate_emails.join(', ')}`);
                    }
                    if (partnership_errors.length > 0) {
                        this.notifyError(this.lang('validation_error'), partnership_errors.join (' & '));
                    }
                    if (validation_errors.length > 0) {
                        this.notifyError(this.lang('validation_error'), message);
                    }
                    return false
                }
            } else if (section === 'OUTLET_INFORMATION') {
                let is_valid_address = this.addressIsValid(this.outlets[0].trading);

                if (!is_valid_address) {
                    if (this.countCharacters(this.outlets[0].trading.house_name) === 0 && this.countCharacters(this.outlets[0].trading.house_number) === 0) {
                        this.setHasErrorClassOnField(['house_name', 'house_number'])

                        this.notifyError(this.lang('validation_error'), this.lang('validation_house_name_number_is_required'))
                    }

                    this.notifyError(this.lang('validation_error'), this.lang('validation_postcode_search'));
                    return false;
                }
            }

            return validate_form;
        },
        runValidationOnFieldChange: function (keyMap = []) {
            //jquery.validate was tweaked for this function to not throw any errors
            let vm = this;
            setTimeout(function () {
                //only  check the passed fields
                if (Array.isArray(keyMap) && vm.objectIsNotEmpty(keyMap)) {
                    keyMap.forEach(field => {
                        let $element = $("[id*='" + field + "']");
                        if ($element.length > 0) {
                            $element.each((obj) => {
                                $($element[obj]).valid()
                            })
                        }
                    })
                } else {
                    //checck the whole page
                    vm.validate('#form', false, false);
                }
            }, 500)
        },
        setHasErrorClassOnField: function (keyMap ){

            let vm = this;
            setTimeout(function () {
                //only  check the passed fields
                if (Array.isArray(keyMap) && vm.objectIsNotEmpty(keyMap)) {
                    keyMap.forEach(obj => {
                        let $element = $("[id*='" + obj + "']");
                        $element.closest('.form-group').addClass('has-error')
                    })
                }
            }, 500)
        },
        getBankType: function (data) {
            let formated_banck_type = '-';
            if (!!this.TYPE_OF_BANK_PARAM && Array.isArray(this.TYPE_OF_BANK_PARAM)) {
                const bank_type = this.TYPE_OF_BANK_PARAM.find((obj) => {
                    return obj.id === data
                });
                if (!!bank_type.text) {
                    formated_banck_type = bank_type.text;
                }
            }

            if (['578'].includes(this.baseCountryCode)) {
                return formated_banck_type.toLowerCase();
            }
            return formated_banck_type;
        },
        bankTypeAllowedForTenant: function(bank_type){
            if(bank_type === '')
            {
                //if blank make visible for decision
                return true
            }
            // console.log(bank_type)
            //access alliance for country_code and alliance_external_id

            let alliance = this.alliance ? this.alliance : null
            alliance = vue_data && vue_data.hasOwnProperty('alliance') ? vue_data.alliance : null;

            let partner = this.getPartner();

            let contact_country = null;
            if (partner && partner.hasOwnProperty('contact_country')) {
                contact_country = partner.contact_country;
            }
            else if (alliance && alliance.hasOwnProperty('contact_country')) {
                contact_country = alliance.contact_country;
            }

            //access parameters for BANK_TYPE_PARAM
            let bank_param = this.parameters && this.parameters.hasOwnProperty('BANK_TYPE_PARAM') ? this.parameters.BANK_TYPE_PARAM :[];

            // console.log('new_bank_config', alliance, bank_param)

            //if BANK_TYPE_PARAM exists do
            if(bank_param.length > 0) {
                //priority: search param by (partner_external_id and alliance_external_id) first if found return results here
                let final_param = null
                if (partner && partner.hasOwnProperty('partner_external_id')) {
                    let bank_param_by_partner = bank_param.filter(obj => { return obj.hasOwnProperty('partner_external_id') && obj.partner_external_id === partner.partner_external_id})
                    final_param = bank_param_by_partner.length > 0 ? bank_param_by_partner : null;
                }
                //if code execution has not returned yet make decision with alliance
                if (alliance && alliance.hasOwnProperty('alliance_external_id')) {
                    let bank_param_by_alliance = bank_param.filter(obj => { return obj.hasOwnProperty('alliance_external_id') && obj.alliance_external_id === alliance.alliance_external_id})
                    final_param = bank_param_by_alliance.length > 0 ? bank_param_by_alliance : null
                    // console.log('bank_param_by_alliance', final_param, bank_param_by_alliance)
                }
                //if code execution has not returned yet make decision with country_code
                if (!final_param && contact_country) {
                    let bank_param_by_country_code = bank_param.filter(obj => { return obj.hasOwnProperty('country_code') && obj.country_code === contact_country})
                    final_param = bank_param_by_country_code.length > 0 ? bank_param_by_country_code : null
                    // console.log('bank_param_by_country_code', final_param, bank_param_by_country_code)
                }

                if(final_param && final_param.length > 0)
                {
                    let response = false;
                    final_param.map(config => {
                        //check if self_boarding && compare bank_type
                        // console.log('config => ', config)
                        if(config.hasOwnProperty('self_boarding') && config.self_boarding === '1' ){
                            if(config.hasOwnProperty('bank_type') && config.bank_type === bank_type)
                            {
                                response = true
                                // console.log(bank_type, ' : is allowd')
                            }
                        }
                    })

                    if(!response)
                        // console.log(bank_type, ' : is not allowd')

                    return response
                }
            }
            //at this point all options dont apply return true: no config to go by : other configs will deal with issue
            // console.log(bank_type, ' : is not allowd')
            return true;
        },
        getBeneficialOwnershipPercentRule: function(principal_logic_configs, rule_level, principal_role){
            let matched_percentage_criteria = {}
            let valid_percentage_criteria = [
                this.PRINCIPAL_RULES.CRITERIA_EQ,
                this.PRINCIPAL_RULES.CRITERIA_GT,
                this.PRINCIPAL_RULES.CRITERIA_GE,
                this.PRINCIPAL_RULES.CRITERIA_LT,
                this.PRINCIPAL_RULES.CRITERIA_LE,
            ];
            let filtered_rules = principal_logic_configs.filter(rule => {
                let is_percentage_criteria = valid_percentage_criteria.includes(rule.rule_criteria)
                return is_percentage_criteria && rule.rule_level === rule_level && rule.principal_role === principal_role
            })

            filtered_rules.forEach(rule => {
                matched_percentage_criteria[rule.rule_criteria] = rule.ownership_percentage;
            })

            return matched_percentage_criteria
        },
        checkAppDefaultFieldIsReadOnly: function(default_field_name) {
            let vm = this;
            if (!vm.hasTenantAppDefaults)
                return false;

            let matched = Object.values(vm.parameters.TENANT_APP_DEFAULTS_PARAM).find(data => {
                if (data['field_name'] === default_field_name){
                    return data;
                }
            });

            return !!matched && matched.hasOwnProperty('selfboarding_readonly') && matched['selfboarding_readonly'] === '1';
        },
        getPartner: function() {
            let vm = this;

            if (vue_data && vue_data.hasOwnProperty('user') && vue_data.user.hasOwnProperty('partner')) {
                return vue_data.user.partner;
            }
            return null;
        },
        isWorkflowActionAllowed: function (action){
           let vm = this;
            let parameters = vm.parameters ? vm.parameters : null;
            if (!!parameters && parameters.hasOwnProperty('APPLICATION_PROCESS_ACTIONS_CHECK') && !!parameters.APPLICATION_PROCESS_ACTIONS_CHECK) {
                let workflow_actions = parameters.APPLICATION_PROCESS_ACTIONS_CHECK;
                return workflow_actions[action] === true;
            }
            return false
        },
        useGiroCard: function () {
            let vm = this;
            if (this.isGermanAlliance && !!vm.outlet && vm.outlet.hasOwnProperty('charges') &&
                vm.outlet.charges.hasOwnProperty('card_type_list') &&
                Array.isArray(vm.outlet.charges.card_type_list)) {
                return vm.outlet.charges.card_type_list.includes('GIROCARD');
            }
            return false;
        },
        retrieveQuote: function (doCall) {
            let vm = this
            return new Promise((resolve, reject) => {
                if (doCall) {
                    let payload = {
                        'user_external_id': vm.user.user_external_id,
                        'quote_external_id': vm.quote.quote_external_id,
                    };

                    vm[types.FETCH_QUOTE_DATA](payload)
                    .then((result) => {
                        resolve(doCall);
                    })
                    .catch((error) => {
                        reject(false);
                    });
                } else {
                    resolve(doCall);
                }
            });
        },
        formatEquipmentOfferForWAF: function (equipment_offer) {
            if (this.npPropertyExistAndIsArray(equipment_offer, 'bundles')) {
                equipment_offer.bundles.forEach(bundle => {
                    if (this.npPropertyExistAndIsArray(bundle, 'bundle_items')) {
                        bundle.bundle_items.forEach(bundle_item => {
                            if (!!bundle_item.equipment && bundle_item.equipment.hasOwnProperty('equipment_description')) {
                                delete bundle_item.equipment.equipment_description;
                            }

                            if (!!bundle_item.service && bundle_item.service.hasOwnProperty('service_description')) {
                                delete bundle_item.service.service_description;
                            }

                            if (this.npPropertyExistAndIsArray(bundle_item, 'equipment_features')) {
                                bundle_item.equipment_features.forEach(feature => {
                                    if (feature.hasOwnProperty('help_text')) {
                                        delete feature.help_text;
                                    }
                                });
                            }

                            if (this.npPropertyExistAndIsArray(bundle_item, 'service_features')) {
                                bundle_item.service_features.forEach(feature => {
                                    if (feature.hasOwnProperty('help_text')) {
                                        delete feature.help_text;
                                    }
                                });
                            }

                            if (this.npPropertyExistAndIsArray(bundle_item, 'service_charges')) {
                                bundle_item.service_charges.forEach(charge => {
                                    if (charge.hasOwnProperty('help_text')) {
                                        delete charge.help_text;
                                    }
                                });
                            }

                            if (this.npPropertyExistAndIsArray(bundle_item, 'equipment_images')) {
                                bundle_item.equipment_images.forEach(image => {
                                    if (image.hasOwnProperty('image_description')) {
                                        delete image.image_description;
                                    }
                                });
                            }

                            if (this.npPropertyExistAndIsArray(bundle_item, 'service_images')) {
                                bundle_item.service_images.forEach(image => {
                                    if (image.hasOwnProperty('image_description')) {
                                        delete image.image_description;
                                    }
                                });
                            }
                        });
                    }
                });
            }

            if (equipment_offer.hasOwnProperty('equipment_offering_config')) {
                delete equipment_offer.equipment_offering_config;
            }

            if (equipment_offer.hasOwnProperty('offer_lookup')) {
                delete equipment_offer.offer_lookup;
            }

            return equipment_offer;
        },
        formatAcquiringOfferForWAF: function (acquiring_offer) {
            if (this.npPropertyExistAndIsArray(acquiring_offer, 'charge_item_groups')) {
                acquiring_offer.charge_item_groups.forEach(charge_item_group => {
                    if (this.npPropertyExistAndIsArray(charge_item_group, 'charge_items')) {
                        charge_item_group.charge_items.forEach(charge_item => {
                            if (charge_item.hasOwnProperty('charge_item_help_text')) {
                                delete charge_item.charge_item_help_text;
                            }
                        });
                    }
                });
            }

            if (this.npPropertyExistAndIsArray(acquiring_offer, 'charge_items')) {
                acquiring_offer.charge_items.forEach(charge_item => {
                    if (charge_item.hasOwnProperty('charge_item_help_text')) {
                        delete charge_item.charge_item_help_text;
                    }
                });
            }

            if (this.npPropertyExistAndIsArray(acquiring_offer, 'service_items')) {
                acquiring_offer.service_items.forEach(service_item => {
                    if (service_item.hasOwnProperty('help_text')) {
                        delete service_item.help_text;
                    }
                });
            }

            if (acquiring_offer.hasOwnProperty('acquiring_offer_config')) {
                delete acquiring_offer.acquiring_offer_config;
            }

            return acquiring_offer;
        },
        unmaskHandler: async function () {
            let vm = this,
                is_masked = vm.merchant.hasOwnProperty('pii_masked') && vm.merchant.pii_masked == '1';
            if (is_masked) {
                let response = await vm[types.UNMASK_PII_DATA]({app_ref: vm.merchant.application_reference});
                let location_href = '/';

                if (!!response && vm.validateRedirectUrl(window.location.href)) {
                    let to_path = window.location.href;
                    if (to_path.includes('/business_details_mask')) {
                        to_path = to_path.replace('/business_details_mask', '');
                    }
                    else if (to_path.includes('edit') && to_path.includes('upload_documents_mask')) {
                        to_path = to_path.replace('upload_documents_mask', 'documents');
                    }
                    else if (to_path.includes('_mask')) {
                        to_path = to_path.replace('_mask', '');
                    }
                    // Fix for SAST scan to check valid url params to prevent Cross-Site Scripting (XSS)
                    const encodedUrl = vm.getEncodedUrl(to_path);
                    if (!!encodedUrl) {
                        location_href = encodedUrl;
                    }
                }
                location.href = location_href;
            }
        },
        validateRedirectUrl: function (location_data) {
            if (!!location_data) {
                // Fix for SAST scan to check valid url to prevent SQL Injection and before calling location.href
                let urlPattern = /^(https:\/\/)?(www\.)?([a-z0-9_.\-]+)(\.[a-z0-9\-]{2,24})(\/[a-z0-9_.\-\/\?=]*)?$/i;
                let valid_url = urlPattern.test(location_data);
                if (valid_url) {
                    return true;
                }
            }
            return false;
        },
        getEncodedUrl: function (url){
            try {
                const parsedUrl = new URL(url);
                const queryParams = parsedUrl.searchParams;
                for (const [key, value] of queryParams) {
                    // Validate keys and values against special character conditions
                    if (/[^a-zA-Z0-9_-]/.test(key) || /[^a-zA-Z0-9_-]/.test(value)) {
                        // Encode the key and value
                        const encodedKey = encodeURIComponent(key);
                        const encodedValue = encodeURIComponent(value);
                        // Use the encoded values to construct a new URL
                        parsedUrl.searchParams.set(encodedKey, encodedValue);
                    }
                }
                return encodeURI(parsedUrl.toString());
            } catch (error) {
                return null;
            }
        },
    },
    watch: {
        "$route.fullPath": {
            handler: function (val, oldVal){
                if (!!val){
                    this.disableContinueBtn = false;

                    // //sometimes we toggle between view ands edit but the root path doesn't update because the quote or application data have already been fetched.
                    // if (this.quote_root_path.includes('/view/') && !!this.isEdit){
                    //     let route = this.quote_root_path.replace('/view/', '/edit/')
                    // }

                }
            }
        },
        'global_errors': {
            handler: function (val, oldVal){
                let vm = this;
                if (!!val && val !== oldVal){
                    //console.log('global_error', val)
                    val.forEach(obj => {
                        vm.notifyError(this.lang('error'), this.lang(obj))
                    })
                }
            },
            immediate: true
        }
    }
};